export class VisibilityColumnsHeader {
    styleClass?: string
    optionLabel?: string
    multiple?: boolean
    metaKeySelection?: boolean
    checkbox?: boolean
    showToggleAll?: boolean
    optionDisabled?: string
}
  